import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { CloudFrontSettings } from '../../../../core/api/models';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import validator from 'validator';

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: CloudFrontSettings) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: CloudFrontSettings;
  error?: string;
}> = (props) => {
  const { control, handleSubmit, errors, watch } = useForm<CloudFrontSettings>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
    shouldUnregister: true,
    defaultValues: props.data,
  });
  const renderUrl = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Url <span className="text-red">*</span></label>
          <Controller
            control={control}
            rules={{
              required: 'Url is required',
              validate: {
                validUrl: (value) => validator.isURL(value) || 'Invalid URL',
              },
            }}
            name="url"
            defaultValue={props.data?.url}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Url"
                name={name}
                value={value}
                onChange={onChange}
                id="url"
              />
            )}
          />
          <ErrorMessage>{errors.url?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderS3BucketName = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">S3 Bucket Name </label>
          <Controller
            control={control}
            name="s3Bucket"
            defaultValue={props.data?.s3Bucket}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="S3 Bucket Name"
                name={name}
                value={value}
                onChange={onChange}
                id="s3Bucket"
              />
            )}
          />
        </div>
      </div>
    );
  };

  const renderRegion = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">S3 Region </label>
          <Controller
            control={control}
            name="region"
            defaultValue={props.data?.region}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="S3 Region"
                name={name}
                value={value}
                onChange={onChange}
                id="region"
              />
            )}
          />
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">
          Update CloudFront Settings
        </h4>
        <div className="row gutter-10">
          {renderUrl()}
          {/* {renderS3BucketName()}
          {renderRegion()} */}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
